import React from 'react'
import { Link } from 'gatsby'

import { useTrackPromotionEvent } from '../../hooks/tracking'

import './event-banner.css'

interface EventBannerProps {
  /** The event date (YYYY-MM-DD). Banner hides after this date. */
  eventDate: string
  /** Link destination */
  href: string
  /** Text for desktop (can be same as mobile) */
  textDesktop: string
  /** Text for mobile (shorter version) */
  textMobile: string
  /** Tracking name for Matomo */
  trackingName?: string
}

const EventBanner = ({
  eventDate,
  href,
  textDesktop,
  textMobile,
  trackingName,
}: EventBannerProps) => {
  const trackPromotion = useTrackPromotionEvent()

  // Hide banner after event date
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const eventDateObj = new Date(eventDate)
  eventDateObj.setHours(23, 59, 59, 999) // Show until end of event day

  if (today > eventDateObj) {
    return null
  }

  const handleClick = () => {
    trackPromotion('Banner Click', trackingName || href)
  }

  return (
    <div className="event-banner">
      <Link to={href} className="event-banner__link" onClick={handleClick}>
        <span className="event-banner__text-desktop">{textDesktop}</span>
        <span className="event-banner__text-mobile">{textMobile}</span>
        <span className="event-banner__arrow">→</span>
      </Link>
    </div>
  )
}

export default EventBanner
